import { render } from "./ResetPassword.vue?vue&type=template&id=0acaf435"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=0acaf435&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/ResetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0acaf435"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0acaf435', __exports__)) {
    api.reload('0acaf435', __exports__)
  }
  
  module.hot.accept("./ResetPassword.vue?vue&type=template&id=0acaf435", () => {
    api.rerender('0acaf435', render)
  })

}


export default __exports__